import { render, staticRenderFns } from "./TaraAttritionCard.vue?vue&type=template&id=294846a6&scoped=true"
import script from "./TaraAttritionCard.vue?vue&type=script&lang=js"
export * from "./TaraAttritionCard.vue?vue&type=script&lang=js"
import style0 from "./TaraAttritionCard.vue?vue&type=style&index=0&id=294846a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294846a6",
  null
  
)

export default component.exports